import { cn } from '@/utils/cn'

export type StoreModelTabValue = 'detail' | 'update' | 'members' | 'groups'

interface Tab {
  value: StoreModelTabValue
  label: string
}

const TABS: Tab[] = [
  { value: 'detail', label: 'Detail' },
  { value: 'update', label: 'Update' },
  { value: 'members', label: 'Members' },
  { value: 'groups', label: 'Groups' },
]

interface StoreModelDetailTabsProps {
  activeTab: StoreModelTabValue
  onTabChange: (tab: StoreModelTabValue) => void
}

export function StoreModelDetailTabs({
  activeTab,
  onTabChange,
}: StoreModelDetailTabsProps) {
  return (
    <div className="inline-flex w-fit rounded-lg border border-accent-border bg-accent p-1">
      {TABS.map(tab => (
        <button
          key={tab.value}
          onClick={() => onTabChange(tab.value)}
          className={cn(
            'px-4 py-2 text-sm font-medium rounded-md transition-colors cursor-pointer',
            'text-[#13254f]',
            activeTab === tab.value ? 'bg-white shadow-sm' : 'hover:bg-white/50'
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
